<template>
  <h1 class="title has-text-centered">
    <go-to-dashboard-button />

    <span v-show="!c2">
      {{ journeysQty }} {{ $t("totemJourneys.title") }}&nbsp;&nbsp;
    </span>

    <br v-show="c1" />

    <button
      class="button"
      @click="$emit('get-journeys')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    &nbsp;
    <span
      :style="
        c1 || c2
          ? 'position: relative; top: -0.1rem;'
          : 'position: relative; top: -1.1rem;'
      "
    >
      <b-datepicker
        style="width: 210px; display: inline-block"
        :placeholder="$t('totemJourneys.selectPeriod')"
        v-model="dates"
        range
        @input="$emit('update-dates', dates)"
        :mobile-native="false"
      ></b-datepicker>
    </span>

    <span v-show="c2" style="position: relative; top: 0.5rem">
      <br />
      {{ journeysQty }} {{ $t("totemJourneys.title") }}
    </span>

    <b-field style="margin-top: 10px">
      <b-select
        :placeholder="$t('totemJourneys.store')"
        class="inline"
        v-model="storeId"
        @input="$emit('update-store', storeId)"
      >
        <option value="">{{ $t("totemJourneys.allStores") }}</option>
        <option v-for="s in orderedStores" :key="s._id" :value="s._id">
          {{ s.storeInfo.name }}
        </option>
      </b-select>
    </b-field>

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  props: ["journeysQty"],

  mixins: [responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      dates: null,
      storeId: ""
    };
  },

  computed: {
    ...mapGetters(["stores", "preferences"]),

    c1() {
      return this.windowWidth < 710 && this.windowWidth > 381;
    },

    c2() {
      return this.windowWidth < 382;
    },

    orderedStores() {
      if (this.preferences.storesOrder === "alphabetical") {
        return [...this.stores].sort((a, b) =>
          a.storeInfo.name.localeCompare(b.storeInfo.name)
        );
      }

      return this.stores;
    }
  },

  mounted() {
    this.dates = [new Date(), new Date()];
  }
};
</script>

<style scoped>
.inline {
  display: inline;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
